<template>
  <div>
    <section class="uk-section uk-container-expand uk-margin-remove-top uk-padding-remove-top">
      <div class="uk-grid uk-grid-collapse">
        <div class="uk-cover-container uk-hidden@m">
          <canvas width="960" height="300"></canvas>
          <img
            :src="require('@/assets/images/rvdsb-1@small-2.png')"
            alt="Stemdemo"
            class="over-roos-cover"
            uk-cover
          />
        </div>
        <image-section-roos
          sub-title="OVER ROOS"
          title="Wie is Roos Netjes?"
        >
          <div class="interactive-voice-main-text">
            In 2013 ben ik afgestudeerd als actrice aan de toneelschool Arnhem (ArtEZ).
            Na 4 jaar intensief stemtraining gevolgd te hebben en verschillende mooie theater, film
            en televisie rollen te hebben gespeeld weet ik met hoeveel verschillende kleuren ik mijn
            stem kan gebruiken.
          </div>
          <br>
          <div class="interactive-voice-sub-text">
            Een stem zegt alles en het is zo leuk om precies de goede tone of
            voice te vinden die helemaal aansluit bij het gevoel van het product. Sinds 2015 heb ik
            veel ervaring met voice-over werk. Vanaf 2016 ben ik de vaste stem voor de Pampers
            reclames. Onder andere heb ik ingesproken voor Sonos, Samsung, Lexa.nl, Pringels,
            Hello Fresh en verschillende educatieve of corporate animaties, videos en voicemails.
          </div>
          <div class="uk-flex uk-margin-medium-top button-flex">
            <div class="voice-over-button uk-display-block small-button-orange
            uk-margin-small-right">
              <router-link :to="{ path: '/', hash: '#contactFormThree' }" class="
        voice-over-button-clickable-section uk-display-block small-button-orange">
                <a class="voice-over-button-text small-button-orange-text text-transform-none">
                  Neem contact op
                </a>
              </router-link>
            </div>
            <div class="voice-over-button uk-display-block small-button-white-bordered
            bottom-button">
              <a href="tel:31641744233" class="voice-over-button-clickable-section
            uk-display-block small-button-white-bordered small-button-white-bordered-border">
                <a class="voice-over-button-text small-button-white-bordered-text
                text-transform-none mijn-tarieven-brown-button">
                  Bel mij direct
                </a>
              </a>
            </div>
          </div>
        </image-section-roos>
        <div class="uk-width-1-2@m uk-cover-container uk-visible@m">
          <img
            :src="require('@/assets/images/rvdsb-1@2x.png')"
            alt="Test - Test - 1, 2, 3. Staat dit ding wel aan?"
            class=""
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ImageSectionRoos from '@/components/ImageSectionRoos.vue';

export default {
  name: 'OverRoos.vue',
  components: { ImageSectionRoos },
};
</script>
<style scoped>
.uk-sticky-placeholder {
  height: 80px !important;
}
</style>
